import { render, staticRenderFns } from "./MediaCarta.vue?vue&type=template&id=24f75c94&scoped=true&"
import script from "./MediaCarta.vue?vue&type=script&lang=js&"
export * from "./MediaCarta.vue?vue&type=script&lang=js&"
import style0 from "./MediaCarta.vue?vue&type=style&index=0&id=24f75c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f75c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VColorPicker,VIcon,VList,VListItem,VListItemTitle,VMenu,VSheet,VTextField,VTooltip})
